define('BrandsPage.List.Collection.View', [
    'SCCollectionView',
    'BrandsPage.List.Details.View',
    'brandspage_collection.tpl',
    'jQuery'
], function (
    SCCollectionViewModule,
    BrandsPageListDetailsView,
    brandspage_collection_tpl,
    jQuery
) {
    'use strict';

    var SCCollectionView = SCCollectionViewModule.SCCollectionView;
    
    function BrandsPageListCollectionView (options) {
        SCCollectionView.call(this, options.collection);
        this.collection = options.collection;

        var brandNames = [];
        for (let i = 0; i < this.collection.models.length; i ++) {
            brandNames.push(this.collection.models[i].attributes.brand)
        }

        const alphaNames = _.sortBy(brandNames);
        var copyOfModels = [];

        for (let i = 0; i < alphaNames.length; i++) {
            for (let j = 0; j < this.collection.models.length; j++) {
                if (alphaNames[i] === this.collection.models[j].attributes.brand) {
                    copyOfModels.push(this.collection.models[j]);
                    break;
                }
            }
        }

        

        this.collection.models = copyOfModels;

        this.template = brandspage_collection_tpl;
        
    }

    BrandsPageListCollectionView.prototype = Object.create(SCCollectionView.prototype);
    BrandsPageListCollectionView.prototype.constructor = BrandsPageListCollectionView;

    BrandsPageListCollectionView.prototype.getCellViewsPerRow = function () {
        return 1
    }

    BrandsPageListCollectionView.prototype.getCellViewInstance = function (model) {

        return new BrandsPageListDetailsView({
            model: model
        })
    }

    BrandsPageListCollectionView.prototype.getContext = function () {
        return {}
    }

    return BrandsPageListCollectionView
})
